import React, { useState } from 'react';
import styles from './UserBlock.module.css';
import { useTranslation } from 'react-i18next';

import Arrow from '@icons/Arrow.svg';
import { Menu, Popover } from '@mantine/core';

import useAuth from '@hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const UserBlock = ({ currentUser }) => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);
  const [, { logout }] = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();

    navigate('/log_in')
    setOpened(false);
  }

  const handleProfile = (...rest) => {
    navigate('/profile');
    setOpened(false);
  }

  return (
    <>
      <Popover width={200} position="bottom" withArrow shadow="md" opened={opened} onChange={setOpened}>
        <Popover.Target onClick={setOpened}>
          <div className={styles.wrapper}>
            <div className={styles.leftBlock}>
              <div className={styles.name}>
                {currentUser.username}
              </div>

              <div className={styles.role}>
                {currentUser.admin ? t('admin') : t('user')}
              </div>
            </div>


            <div className={styles.iconBlock}>
              <img src={Arrow} />
            </div>
          </div>
        </Popover.Target>

        <Popover.Dropdown style={{ background: '#fff', boxShadow: '0px 2px 8px 0px #00000033' }}>
          <Menu>
            <Menu.Item onClick={handleProfile} className={styles.menuItem}>
              {t('profile')}
            </Menu.Item>

            <Menu.Item onClick={handleLogout} className={styles.menuItemLogout}>
              {t('logout')}
            </Menu.Item>
          </Menu>
        </Popover.Dropdown>
      </Popover>
    </>
  )
}

export default UserBlock;
